import { getServicesList } from '@/api/services.wp.api'

const state = {
	servicesList: {
		'de-ch': [],
		'en-us': []
	},
	loading: true
}

const actions = {
	loadServices: ({ commit, state }, payload) => {
		if (!state.servicesList[payload].length) {
			getServicesList(payload).then(response => {
				commit('SERVICES_LIST_LOAD')
				commit('SERVICES_LIST_SAVE', response.data)
			})
		}
	}
}

const mutations = {
	SERVICES_LIST_LOAD: (state) => {
		state.loading = true
	},
	SERVICES_LIST_SAVE: (state, services) => {
		state.loading = false
		state.servicesList[services[0].lang] = services
	}
}

const getters = {
}

export default {
	state,
	actions,
	mutations,
	getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/services.store.js